import React from "react";

import { hasOwn } from "../../commonFunctions/arrayFunc";
import "./StateMachine.css";

const OwnerAssignmentCard = ({ ownerAssignment, allGroups, allRdbms }) => {
  let {
    groups = [],
    designations = [],
    type,
    roles = [],
    rdbms_group_template_id
    // community_groups = []
  } = ownerAssignment;
  if (!groups) groups = [];
  if (!roles) roles = [];
  // if (!community_groups) community_groups = [];
  if (!designations) designations = [];
  let array = [];
  if (hasOwn(ownerAssignment, "can_reassign")) {
    array = ["can_reassign", "copy_parent_rule", "multiselect"];
  } else {
    array = ["multiselect", "allow_next_activity_assignment"];
  }

  let checkedContentArray = array.filter((prop) => ownerAssignment[prop]);

  const isEmptyOwnerAssignment =
    groups.length === 0 &&
    // community_groups.length === 0 &&
    roles.length === 0 &&
    designations.length === 0 &&
    checkedContentArray.length === 0 &&
    type !== "Anyone" &&
    !rdbms_group_template_id;

  // Error handling based on the type
  let errorMessage = null;
  if (type === "group" && groups.length === 0) {
    errorMessage = "Group error";
  }
  //  else if (type === "community_groups" && community_groups.length === 0) {
  //   errorMessage = "Group error";
  // }
  else if (type === "role" && roles.length === 0) {
    errorMessage = "Role error";
  } else if (type === "designation" && designations.length === 0) {
    errorMessage = "Designation error";
  } else if (type === "uid") {
    errorMessage = "The assigned user can perform this activity";
  }
  const getRdbmsName = (rdbmsId) => {
    const rdbms = allRdbms.find((rdbms) => rdbms.id === rdbmsId);
    return rdbms ? rdbms.name : rdbmsId;
  };

  return (
    <div className="stateMachine_form_container" style={{ margin: "4px auto", width: "100%", gap: "8px" }}>
      {errorMessage && (
        <div>
          <p>{errorMessage}</p>
        </div>
      )}
      {!errorMessage && (
        <>
          {isEmptyOwnerAssignment && (
            <div className="key_tag">
              <p>Anyone can perform this activity</p>
            </div>
          )}
          {!isEmptyOwnerAssignment && (
            <>
              {groups.length > 0 && (
                <div>
                  <label className="builder_label">Groups:</label>
                  <span className="key_tag" style={{ padding: "4px" }}>
                    {groups
                      .map((groupId) => {
                        const group = allGroups.find((group) => group.id === groupId);
                        return group ? group.name : groupId;
                      })
                      .join(", ")}
                  </span>
                </div>
              )}
              {/* {community_groups.length > 0 && (
                <div>
                  <label className="builder_label">Community Groups:</label>
                  <span className="key_tag" style={{ padding: "4px" }}>
                    {community_groups
                      .map((groupId) => {
                        const group = allCommunityGroups.find((group) => group.id === groupId);
                        return group ? group.name : groupId;
                      })
                      .join(", ")}
                  </span>
                </div>
              )} */}
              {roles.length > 0 && (
                <div>
                  <label className="builder_label">Roles (Code — Name):</label>
                  <span className="key_tag" style={{ padding: "4px" }}>
                    {roles.map((r) => `${r.role_code} (${r.name})`).join(", ")}
                  </span>
                </div>
              )}
              {designations.length > 0 && (
                <div>
                  <label className="builder_label">Designations:</label>
                  <span className="key_tag" style={{ padding: "4px" }}>
                    <span>{designations.join(", ")}</span>
                  </span>
                </div>
              )}

              {rdbms_group_template_id && (
                <div>
                  <label className="builder_label">Rdbms Group Template:</label>
                  <span className="key_tag" style={{ padding: "4px" }}>
                    {getRdbmsName(rdbms_group_template_id)}
                  </span>
                </div>
              )}

              <div>
                <label className="builder_label">Type:</label>
                <span className="key_tag" style={{ padding: "4px" }}>
                  {type}
                </span>
              </div>
              {checkedContentArray.length > 0 && (
                <div>
                  <label className="builder_label">
                    {checkedContentArray
                      .filter((item) => ownerAssignment[item])
                      .map((item, index, array) => (
                        <React.Fragment key={item}>
                          <span>{item}</span>
                          {index !== array.length - 1 && ", "}
                        </React.Fragment>
                      ))}
                    :{" "}
                    <span className="key_tag" style={{ padding: "4px" }}>
                      Yes
                    </span>
                  </label>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default OwnerAssignmentCard;
